import { render, staticRenderFns } from "./NoArtwork.vue?vue&type=template&id=05a00565&"
import script from "./NoArtwork.vue?vue&type=script&lang=js&"
export * from "./NoArtwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NoArtwork.vue"
export default component.exports